(() => {
  'use strict';
  function mount(root) {
    if (root.dataset.mounted) return;
    const form = root.closest('form');
    if (!form) return;
    root.dataset.mounted = 'true';
    const catalog = JSON.parse(root.querySelector('[data-flower-catalog]').textContent);
    const messages = JSON.parse(root.querySelector('[data-flower-messages]').textContent);
    const slots = ['second', 'earrings', 'keyring'];
    const discounts = { second: 900, earrings: 500, keyring: 600 };
    const toggle = slot => root.querySelector(`[data-bump="${slot}"]`);
    const field = name => root.querySelector(`[data-field="${name}"]`);
    const value = name => {
      const element = field(name);
      return element?.type === 'radio' ? root.querySelector(`[data-field="${name}"]:checked`)?.value || '' : element?.value || '';
    };
    const selectedSlots = () => slots.filter(slot => toggle(slot).checked);
    const money = cents => '€' + (Number(cents) / 100).toFixed(2).replace('.', ',');
    const text = (element, string) => { if (element && element.textContent !== string) element.textContent = string; };
    const status = root.querySelector('[data-bump-status]');
    const mainVariant = () => catalog.necklace.find(variant => String(variant.id) === String(form.querySelector('input[name="id"]')?.value));
    const quantity = () => Math.max(1, Number(new FormData(form).get('quantity')) || 1);
    const variantFor = slot => slot === 'main' ? mainVariant() : (catalog[slot === 'second' ? 'necklace' : slot] || []).find(variant => variant.options[0] === (slot === 'keyring' ? 'Сребърно' : value(slot + '-color')));
    const showStatus = (message, error = false) => {
      status.hidden = false;
      status.classList.toggle('error', error);
      text(status, message);
    };
    let submitting = false, requestId = null, requestSignature = null;
    function sync() {
      let total = Number(mainVariant()?.price || 0) * quantity(), savings = 0;
      for (const slot of slots) {
        const input = toggle(slot);
        if (!(catalog[slot === 'second' ? 'necklace' : slot] || []).some(variant => variant.available !== false)) {
          input.checked = false;
          input.disabled = true;
        }
        const settings = root.querySelector(`[data-settings="${slot}"]`);
        settings.hidden = !input.checked;
        settings.disabled = !input.checked;
        input.setAttribute('aria-expanded', String(input.checked));
        input.closest('.aur-bump-card').dataset.selected = String(input.checked);
        const variant = variantFor(slot);
        if (variant) {
          text(root.querySelector(`[data-old="${slot}"]`), money(variant.price));
          text(root.querySelector(`[data-price="${slot}"]`), money(variant.price - discounts[slot]));
        }
        if (input.checked && variant) { total += Number(variant.price) - discounts[slot]; savings += discounts[slot]; }
        if (slot === 'earrings') continue;
        const cardOn = input.checked && field(slot + '-card-toggle').checked;
        const cardSettings = root.querySelector(`[data-card-settings="${slot}"]`);
        cardSettings.hidden = !cardOn;
        cardSettings.disabled = !cardOn;
        const customCard = cardOn && value(slot + '-card') === 'Свободен текст';
        const customSettings = root.querySelector(`[data-card-text="${slot}"]`);
        customSettings.hidden = !customCard;
        customSettings.disabled = !customCard;
        const option = field(slot + '-card').selectedOptions[0];
        const preview = root.querySelector(`[data-card-preview="${slot}"]`);
        preview.hidden = !cardOn || !option?.dataset.image;
        if (option?.dataset.image) { preview.src = option.dataset.image; preview.alt = option.textContent; }
      }
      root.querySelector('[data-total-wrap]').hidden = savings === 0;
      text(root.querySelector('[data-bump-total]'), money(total));
      text(root.querySelector('[data-bump-saving]'), messages.savings.replace('{{ amount }}', money(savings)));
    }
    function markInvalid(element, label) {
      showStatus(messages.required.replace('{{ field }}', label), true);
      const container = element.closest('.gpo-element,.aur-bump-field') || element;
      container.scrollIntoView({ block: 'center' });
      element.focus({ preventScroll: true });
    }
    function primaryProperties() {
      const app = document.querySelector('.gpo-app[data-option-set-id="1143885"]');
      if (!app || !app.querySelector('input[data-name]')) throw new Error(messages.main_loading);
      const inputs = Array.from(app.querySelectorAll('input[data-name],select[data-name],textarea[data-name]')).filter(input => !input.disabled);
      const checkedNames = new Set();
      for (const input of inputs.filter(input => input.hasAttribute('presence'))) {
        if (input.type === 'radio' || input.type === 'checkbox') {
          if (checkedNames.has(input.name)) continue;
          checkedNames.add(input.name);
          if (inputs.some(other => other.name === input.name && other.checked)) continue;
        } else if (input.value.trim()) continue;
        markInvalid(input, input.getAttribute('data-field-name') || input.name);
        return null;
      }
      const properties = {};
      for (const [name, val] of new FormData(form)) {
        const match = name.match(/^properties\[(.+)\]$/);
        if (match && typeof val === 'string' && val.trim()) properties[match[1]] = val;
      }
      for (const input of inputs) {
        if ((input.type === 'radio' || input.type === 'checkbox') && !input.checked) continue;
        if (!input.value.trim()) continue;
        const match = input.getAttribute('data-name').match(/^properties\[([^\]]+)\]/);
        if (match) properties[match[1]] = input.value.trim();
      }
      return properties;
    }
    function giftProperties(slot) {
      const properties = {};
      if (slot !== 'earrings') {
        properties['Добави рождено цвете'] = value(slot + '-flower');
        properties[slot === 'keyring' ? 'Напиши буква 1 за гравиране' : 'Напиши буква за гравиране'] = value(slot + '-letter').trim().normalize('NFC').toLocaleUpperCase('bg');
        properties['Изберете шрифт за гравиране'] = value(slot + '-font');
        if (field(slot + '-card-toggle').checked) {
          properties['Добави безплатна картичка'] = 'Добави безплатна картичка';
          properties['Избери картичка'] = value(slot + '-card');
          if (value(slot + '-card') === 'Свободен текст') properties['Текст за картичката'] = value(slot + '-card-text').trim();
        }
      }
      if (slot === 'second') properties['Добави рожден камък'] = value(slot + '-stone');
      if (slot === 'earrings') {
        const [month, stone] = value('earrings-stone').split(' - ');
        properties['Рожден месец'] = month;
        properties['Рожден камък'] = stone;
      }
      return properties;
    }
    const cartRoot = window.Shopify?.routes?.root || '/';
    async function readCart() {
      const response = await fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error(messages.cart_error);
      return response.json();
    }
    const placed = cart => new Set(cart.items.filter(item => item.properties?._aurore_offer_id === requestId).map(item => item.properties._aurore_offer_slot));
    async function submit() {
      if (submitting) return;
      sync();
      let primary;
      try { primary = primaryProperties(); } catch (error) { showStatus(error.message, true); status.focus(); return; }
      if (!primary) return;
      for (const slot of selectedSlots().filter(slot => slot !== 'earrings')) {
        const letter = field(slot + '-letter');
        letter.setCustomValidity(/^\p{L}$/u.test(letter.value.trim().normalize('NFC')) ? '' : messages.letter_error);
        const cardText = field(slot + '-card-text');
        cardText.setCustomValidity(cardText.disabled || cardText.closest('fieldset').disabled || cardText.value.trim() ? '' : messages.required.replace('{{ field }}', messages.card_text.replace(' *', '')));
      }
      const invalid = Array.from(form.elements).find(element => element.willValidate && !element.checkValidity());
      if (invalid) {
        markInvalid(invalid, invalid.closest('fieldset')?.querySelector('legend')?.textContent || invalid.name);
        invalid.reportValidity();
        return;
      }
      const activeSlots = ['main', ...selectedSlots()];
      const items = activeSlots.map(slot => ({ id: variantFor(slot)?.id, quantity: slot === 'main' ? quantity() : 1, properties: slot === 'main' ? primary : giftProperties(slot) }));
      if (activeSlots.some(slot => !variantFor(slot) || variantFor(slot).available === false)) { showStatus(messages.unavailable, true); return; }
      const button = form.querySelector('button[name="add"],#aurBenCta,button[type="submit"]');
      const wasDisabled = button.disabled;
      submitting = true;
      button.disabled = true;
      const locked = Array.from(new Set([...form.elements, ...document.querySelectorAll('.gpo-app input,.gpo-app select,.gpo-app textarea')])).filter(element => 'disabled' in element).map(element => [element, element.disabled]);
      locked.forEach(([element]) => { element.disabled = true; });
      form.setAttribute('aria-busy', 'true');
      showStatus(messages.loading);
      try {
        const before = await readCart();
        const signature = JSON.stringify(items);
        if (requestId && signature !== requestSignature && placed(before).size) throw new Error(messages.changed_error);
        if (!requestId || signature !== requestSignature) requestId = crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2);
        requestSignature = signature;
        items.forEach((item, index) => Object.assign(item.properties, { _aurore_offer_id: requestId, _aurore_offer_slot: activeSlots[index], _aurore_offer_family: 'letter-flower', 'Комплект': messages[activeSlots[index]] }));
        const present = placed(before);
        const missing = items.filter((item, index) => !present.has(activeSlots[index]));
        if (missing.length) {
          let response, result;
          try {
            response = await fetch(cartRoot + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ items: missing }) });
            result = await response.json();
          } catch (error) {
            const current = await readCart();
            if (!activeSlots.every(slot => placed(current).has(slot))) throw new Error(messages.add_error);
          }
          if (response && (!response.ok || result.status)) {
            const current = await readCart();
            if (!activeSlots.every(slot => placed(current).has(slot))) throw new Error(typeof result.description === 'string' ? result.description : messages.add_error);
          }
        }
        let cart = await readCart();
        for (let index = 0; index < items.length; index++) {
          const line = cart.items.find(item => item.properties?._aurore_offer_id === requestId && item.properties._aurore_offer_slot === activeSlots[index]);
          if (!line || Object.entries(items[index].properties).some(([key, val]) => String(line.properties[key]) !== String(val))) throw new Error(messages.verify_error);
        }
        if (!window.AuroreGiftDiscounts) throw new Error(messages.discount_error);
        cart = (await window.AuroreGiftDiscounts.sync(cart)).cart;
        window.location.assign(cartRoot + 'cart');
      } catch (error) {
        submitting = false;
        locked.forEach(([element, disabled]) => { element.disabled = disabled; });
        button.disabled = wasDisabled;
        form.removeAttribute('aria-busy');
        showStatus(error.message || messages.add_error, true);
        const link = document.createElement('a');
        link.href = cartRoot + 'cart';
        link.textContent = messages.view_cart;
        status.append(document.createElement('br'), link);
        status.focus();
      }
    }
    root.addEventListener('change', () => { status.hidden = true; sync(); });
    root.addEventListener('input', event => { event.target.setCustomValidity?.(''); });
    document.addEventListener('change', () => setTimeout(sync, 60));
    window.addEventListener('click', event => {
      const button = event.target.closest('button');
      if (!button || button.form !== form || button.type !== 'submit' || !selectedSlots().length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      submit();
    }, true);
    window.addEventListener('submit', event => {
      if (event.target !== form || !selectedSlots().length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      submit();
    }, true);
    sync();
  }
  const init = () => document.querySelectorAll('[data-aur-flower-bumps]').forEach(mount);
  init();
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(init).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
})();
